import React from 'react';
import { Stack, StackProps, styled } from '@mui/material';

import { AvatarS3PhotoKey } from './ui/Avatar/AvatarS3PhotoKey';

type ContactInfoCardProps = {
  name?: React.ReactNode;
  initials?: string | null;
  description?: string | null;
  s3PhotoKey?: string | null;
  avatar?: React.ReactNode;
  email?: string | null;
  phone?: string | null;
} & StackProps;

export const ContactInfoCard: React.FC<ContactInfoCardProps> = ({
  name,
  initials,
  description,
  s3PhotoKey,
  avatar,
  email,
  phone,
  ...props
}) => {
  return (
    <StyledContactInfoCard {...props}>
      {avatar ? (
        avatar
      ) : (
        <AvatarS3PhotoKey s3PhotoKey={s3PhotoKey}>{initials}</AvatarS3PhotoKey>
      )}
      <Stack className="text-container">
        <Stack className="name-description">
          <span className="name nowrap ">{name}</span>
          <span className="description nowrap overflow">{description}</span>
        </Stack>
        <Stack className="email-phone">
          {email && <span className="email nowrap ">{email}</span>}
          {phone && <span className="phone nowrap overflow">{phone}</span>}
          {!email && !phone && (
            <span className="no-email-or-phone nowrap overflow">
              No email or phone number
            </span>
          )}
        </Stack>
      </Stack>
    </StyledContactInfoCard>
  );
};

const StyledContactInfoCard = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  fontSize: '14px',
  '.text-container': {
    overflow: 'hidden'
  },
  '.MuiAvatar-root': {
    height: 32,
    width: 32,
    fontSize: '1rem'
  },
  '.name-description': {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px'
  },
  '.name': {
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  '.description': {
    color: '#667A86'
  },
  '.email-phone': {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px'
  },
  '.email': {
    color: '#009BD0'
  },
  '.nowrap': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  '.overflow': {
    overflow: 'hidden'
  },
  '.no-email-or-phone': {
    color: '#DD3730'
  }
});
